var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text.length)?_c('div',{staticClass:"result__wrapper"},[_c('p',{staticClass:"team-result__text",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }